import { LiveComponent } from "./LiveComponent";
import { LivePropsUpperBound } from "./LiveComponentSource";
import { RemoteComponentProps } from "./RemoteComponent";

/**
 * Factory for building a LiveComponent, enabling better readability when using live components.
 * FIXME: this is not "wrapped" in the vend call, should we remove this?
 * FIXME: no one is using this, let's remove it :)
 */
export function createLiveComponent<T extends LivePropsUpperBound = any>(remoteProps: RemoteComponentProps) {
  const renderedComponent = (componentProps: T) => <LiveComponent {...remoteProps} {...componentProps} />;
  return renderedComponent;
}
